<div class="agenda-page">
  <header class="page-header">
    <h1>{{ title }}</h1>
    <button mat-stroked-button (click)="goToToday()" [disabled]="loading || error || !canView"><mat-icon>today</mat-icon>Hoy</button>
  </header>
  @if (loading) {
    <div class="state" role="status"><mat-spinner diameter="32"></mat-spinner><p>Cargando {{ title.toLowerCase() }}…</p></div>
  } @else if (!canView) {
    <p class="state">No tenés acceso a esta información de la unidad.</p>
  } @else if (error) {
    <div class="state" role="alert"><p>No se pudo cargar {{ title.toLowerCase() }}.</p><button mat-stroked-button (click)="retry.emit()">Reintentar</button></div>
  } @else {
    <div #agendaList>
      @for (month of months; track month.year + '-' + month.month) {
        <section class="agenda-month" [attr.data-current-month]="month.isCurrent" [attr.aria-label]="month.label + ' ' + month.year">
          <h2>{{ month.label }} @if (month.isCurrent) { <span>(Este mes)</span> } @else if (month.year !== currentYear) { <span>{{ month.year }}</span> }</h2>
          @for (day of month.days; track day.day) {
            @if (preferUpcoming && month.isCurrent && !day.isPast && ($first || month.days[$index - 1].isPast)) {
              <ng-container *ngTemplateOutlet="todayMarker"></ng-container>
            }
            <div class="agenda-day" [class.is-today]="day.isToday" [class.is-past]="day.isPast" [attr.data-today]="day.isToday" [attr.data-past]="day.isPast ?? false">
              <div class="date-badge">
                <span class="weekday">{{ day.weekday }}</span><strong>{{ day.day }}</strong>
                @if (day.isToday) { <span class="date-caption">HOY</span> }
                @else if (!day.weekday) { <span class="date-caption">Bisiesto</span> }
              </div>
              <div class="day-items">
                @for (item of day.items; track $index) {
                  <div class="agenda-item"><ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item, isPast: day.isPast }"></ng-container></div>
                }
              </div>
            </div>
          } @empty { <p class="empty-month">{{ emptyMessage }}</p> }
          @if (preferUpcoming && month.isCurrent && !hasUpcomingDays(month)) {
            <ng-container *ngTemplateOutlet="todayMarker"></ng-container>
          }
        </section>
      }
      @if (preferUpcoming && !hasUpcomingItems) {
        <div class="state upcoming-empty" data-upcoming-empty>{{ upcomingEmptyMessage }}</div>
      }
    </div>
  }
</div>

<ng-template #todayMarker>
  <div class="today-marker" data-today-marker role="separator" aria-label="Hoy">
    <span>Hoy · {{ today | date:'dd-MMM' }}</span>
  </div>
</ng-template>
